<template>
    <div>
        <label class="w-full"> Categoria </label>

        <a-select
            size="large"
            class="mt-2 w-full mb-6"
            show-search
            :value="pType"
            placeholder="Digite a descrição de uma categoria"
            style="width: 100%"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            @change="selectPTypeOption"
        >
            <template v-slot:notFoundContent>
                Nenhuma opção encontrada
            </template>
            
            <a-select-option v-for="d in availablePTypes" :key="d.id">
                {{ d.label }} 
            </a-select-option>

            <div slot="dropdownRender" slot-scope="menu">
                <v-nodes :vnodes="menu" />
                <a-divider style="margin: 4px 0;" />
                <div style="padding: 4px 8px; cursor: pointer;" @click="showPTypeInsert()" v-if="selectedMenuId">
                    <a-icon type="plus"/> Incluir Categoria
                </div>
            </div>
        </a-select>

        <CreateNewProductType
            :visible.sync="modalFrmAddEdit.visible"
            :menuID="selectedMenuId"
            :lastOrderNumber="availablePTypes.length"/>
    </div>
</template>

<script>
    import firebase from '@/firebase/firebase'
    import { mapState, mapMutations } from 'vuex'
    import vSelect from 'vue-select'
    import CreateNewProductType from '@/components/productType/CreateNewProductType'

    export default {
        components : {
          CreateNewProductType,
          vSelect,
          VNodes: {
            functional: true,
            render: (h, ctx) => ctx.props.vnodes,
          },
        },

        data () {
            return {
                pTypeData : [],
                modalFrmAddEdit: {
                    visible: false,
                }
            }
        },

        computed : {
            selectedMenuId () {
                return this.productInfo.productType.menuId || ''
            },

            availablePTypes () {
                return this.pTypeData.filter(p => p.menuId == this.selectedMenuId) || []
            },

            pType () {
              const selectedPTypeId = this.productInfo.productType.id
              return selectedPTypeId || ''
            },

            ...mapState('product', ['productInfo'])
        },

        mounted () {
            this.fetchProductType()
        },

        methods : {
            showPTypeInsert () {
              this.modalFrmAddEdit.visible = true
            },

            fetchProductType () {
                let companyId = this.$store.getters.getCompanyID
                firebase.firestore().collection(`/company/${companyId}/productType`)
                    .where('active', '==', true)
                    .onSnapshot((snapshot) => {
                        snapshot.docChanges().forEach(change => {
                            let pType = { ...change.doc.data(), id: change.doc.id }

                            if (change.type === "added") {
                                this.addToProductType(pType)
                            }
                            if (change.type === "modified") {
                                this.changeProductType(pType)
                            }
                            if (change.type === "removed") {
                                this.removePType(pType)
                            }
                        })
                    })
            },

            selectPTypeOption (selectedPTypeId) {
              const foundPTypeLocal = this.pTypeData.find(p => p.id == selectedPTypeId)
              
              if(foundPTypeLocal)
                this.setProductType({
                  id : selectedPTypeId,
                  description : foundPTypeLocal.label,
                  menuId : foundPTypeLocal.menuId
                })
            },

            addToProductType (pType) {
                this.pTypeData.push({
                    id : pType.id,
                    label: pType.description,
                    menuId : pType.menu
                })
                this.setSelection(pType);
            },

            changeProductType (pTypeChanged) {
                const foundPType = this.pTypeData.findIndex(p => p.id == pTypeChanged.id)
                if(foundPType >= 0) {
                    this.pTypeData[foundPType] = {
                        id : pTypeChanged.id,
                        label : pTypeChanged.description,
                        menuId : pTypeChanged.menu
                    }
                }
            },

            setSelection (pType) {
                if (this.$route.query && this.$route.query.productTypeId && pType.id === this.$route.query.productTypeId)
                    this.selectPTypeOption(pType.id)
            },

            removePType (pType) {
                let foundPType = this.pTypeData.findIndex(a => a.id == pType.id)

                if(foundPType < 0) return
                
                this.$delete(this.productTypeData, foundPType)
            },

            ...mapMutations('product', ['setProductType'])
        }
    }
</script>